import { render, staticRenderFns } from "./PlusPromptComposer.vue?vue&type=template&id=0aea98ad&scoped=true"
import script from "./PlusPromptComposer.vue?vue&type=script&lang=js"
export * from "./PlusPromptComposer.vue?vue&type=script&lang=js"
import style0 from "./PlusPromptComposer.vue?vue&type=style&index=0&id=0aea98ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aea98ad",
  null
  
)

export default component.exports